import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import ChevronDownArrow from "@app/components/select/chevron-down";
import { CustomSelect } from "@app/components/select/custom-select";
import { addToast } from "@app/components/toast/toast.service";
import { SystemMessage, ActiveOptions } from "@app/constants";
import UserService from "@app/services/http/user.service";
import { BankAuthor } from "@app/types";
import useForceUpdate from "@core/hooks/use-force-update.hook";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const BankAccountTab = () => {
  const { userId } = useParams();
  const [bankAuthor, setBankAuthor] = useState<BankAuthor>();

  const [update, forceUpdate] = useForceUpdate();

  useEffect(() => {
    UserService.getAuthorBankInfo(Number(userId)).then((res) => {
      if (res?.data) setBankAuthor(res.data);
    });
  }, [update]);

  const handleSubmit = async (values: { isActive: boolean | string }) => {
    const isActiveBoolean = values.isActive === "true";

    await UserService.updateAuthorBankIsActive(
      Number(bankAuthor?.id),
      isActiveBoolean
    );

    addToast({ text: SystemMessage.UPDATE_SUCCESSFULLY });

    forceUpdate();
  };

  return (
    <>
      {bankAuthor ? (
        <div className="p-4 w-[30%]">
          <div className="grid grid-cols-2 gap-4">
            <div className="font-semibold">Tên ngân hàng:</div>
            <div>{bankAuthor?.bankName}</div>

            <div className="font-semibold">Số tài khoản:</div>
            <div>{bankAuthor?.bankNumber}</div>

            <div className="font-semibold">Chủ tài khoản:</div>
            <div>{bankAuthor?.bankOwner}</div>

            <div className="font-semibold">Trạng thái:</div>
            <div>{bankAuthor?.isActive ? "Active" : "Inactive"}</div>
          </div>
          <div className="mt-8">
            <Formik
              initialValues={{
                isActive: bankAuthor?.isActive.toString() ?? false,
              }}
              onSubmit={handleSubmit}
              validateOnBlur
              validateOnChange
              enableReinitialize
            >
              {({ resetForm }) => (
                <Form>
                  <div>
                    <div className="text-sm mt-4 font-semibold">Hành động</div>
                    <FormControl name="isActive">
                      <CustomSelect
                        options={ActiveOptions}
                        className="bg-color w-full !h-[52px] px-1 mt-1 rounded-lg pr-4"
                        optionContainerClassName="mt-4 rounded-b-lg w-full overflow-y-auto w-36"
                        optionClassName="whitespace-nowrap px-3  border-b border-solid w-auto"
                        labelSelectedClassName="black-50 !mx-3"
                        placeholder="Loại"
                        arrow={<ChevronDownArrow />}
                        hasBgColorHover
                      />
                    </FormControl>
                  </div>

                  <div className="flex">
                    <Button
                      containerClassName="mt-[60px]"
                      width="auto"
                      type="submit"
                      className="!w-[118px] !h-[52px] font-medium !rounded-xl"
                      label="Cập nhật"
                    />
                    <Button
                      containerClassName="mt-[60px] ml-6"
                      width="auto"
                      className="!w-[118px] !h-[52px] font-medium !rounded-xl"
                      label="Hủy"
                      theme="secondary"
                      onClick={() => resetForm()}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      ) : (
        <p>Không phải author</p>
      )}
    </>
  );
};

export default BankAccountTab;
